import type { InjectionKey } from 'vue'

import type { Grade } from '@backmarket/http-api/src/api-models/Grade'
import type { LinkInternal } from '@backmarket/http-api/src/api-models/LinkInternal'
import type { Price } from '@backmarket/http-api/src/api-models/Price'
import type { Deal } from '@backmarket/nuxt-layer-cms/products/algolia/types'
import type { Location } from '@ds/types/Location'

import type {
  ComparisonProduct,
  Granularity,
  MarketingTag,
  Product,
} from '../../models/product'

export type AddToCartSuccessMode = 'popover' | 'silent'
export type AddToCartErrorMode = 'popover' | 'inline'

export const addToCartSuccessModeKey: InjectionKey<AddToCartSuccessMode> =
  Symbol('addToCartSuccessMode')

export const addToCartErrorModeKey: InjectionKey<AddToCartErrorMode> =
  Symbol('addToCartErrorMode')

export interface ProductCardProduct {
  description?: string
  discountedPrice?: Price
  imageSrc: string
  listingId: string
  listingPublicId: string
  price: Price
  priceNew?: Price
  reviewRating?: {
    count: number
    average: number
  }
  title: string
  url: string | LinkInternal | Location
  grade?: Grade
  productType?: 'Refurbished' | 'Brand new' | 'Digital'
  warranty?: number
  specifications?: Array<{
    label: string
    values: string[]
  }>
  colorSwatches?: Array<{ name: string; value?: string }>
  isComparisonEnabled?: boolean
  comparisonProducts?: ComparisonProduct[]
  isComparisonAddProductDisabled?: boolean
  isResponsiveComparisonEnabled?: boolean
  deals?: Deal[]
  rawProduct: Product
  granularity?: Granularity
  specialOfferType?: number
  marketingTags?: MarketingTag[]
}
